
<!--
    SSO-3581: the Mux playback id that sits beside every YouTube video field. The v2 app
    streams it and falls back to the YouTube link when it is empty, so the two live side
    by side while both apps are live. Single-valued by default — one Mux asset carries every
    language as a separate audio track. Workout collections are per language (SSO-3682: a coach
    may film the intro once per language) and put their translations modal in the `actions` slot.

    The poster frame is the only practical guard against a pasted *asset* id, which looks
    identical but is a private handle the player cannot stream: a wrong id simply renders
    nothing, which is exactly the signal an admin needs.
-->
<div v-if="readonly">
    <template v-if="value">
        <div class="form-subtitle">{{ label }}:</div>
        <div class="form-subtitle-description">{{ value }}</div>
        <img
            v-if="posterUrl"
            :src="posterUrl"
            :alt="value"
            width="200"
            class="bordered mb-4"
            @error="broken = true"
        />
    </template>
</div>
<div v-else class="form-group-horizontal">
    <div class="horizontal-label">{{ label }}</div>
    <div class="horizontal-input">
        <v-text-field
            :value="value"
            type="text"
            outlined
            dense
            :error-messages="errors"
            @input="(v) => $emit('input', v)"
        ></v-text-field>
    </div>
    <!--
        The note and the poster live in the second column: the input's own hint slot pushes
        this row's content into the next one (see .horizontal-actions.field-note, SSO-3550).
    -->
    <div class="horizontal-actions field-note">
        <div v-if="$scopedSlots.actions"><slot name="actions"></slot></div>
        {{ t('general_text_mux_playback_id_hint') }}
        <img
            v-if="posterUrl"
            :src="posterUrl"
            :alt="value"
            width="200"
            class="bordered d-block mt-2"
            @error="broken = true"
        />
    </div>
</div>
